// OGC-531 Creatives Manager v19 ad preview: a Facebook-feed layout with a
// sample business identity. Each campaign uses the customer's connected Page.
// The media frame takes the media's own shape (portrait creatives stay
// portrait) and never crops it; it is 4:3 only until the shape is known.
import { useEffect, useState } from 'react';
import CatalogVideo from './CatalogVideo.jsx';

export const CTA_LABELS = Object.freeze({
  LEARN_MORE: 'Learn more',
  GET_QUOTE: 'Get quote',
  CONTACT_US: 'Contact us',
  SIGN_UP: 'Sign up',
  APPLY_NOW: 'Apply now',
});

export const SAMPLE_BUSINESS = Object.freeze({
  name: 'Oak & Stone Renovations',
  initial: 'O',
  domain: 'OAKANDSTONE.EXAMPLE',
});

const validSize = (width, height) => (Number(width) > 0 && Number(height) > 0 ? { width: Number(width), height: Number(height) } : null);

export function AdPreview({ primaryText, headline, callToAction, videoUrl = '', posterUrl = '', mediaLabel = 'Renovation creative', mediaWidth = 0, mediaHeight = 0 }) {
  const known = validSize(mediaWidth, mediaHeight);
  const [measured, setMeasured] = useState(null);
  useEffect(() => { setMeasured(null); }, [videoUrl, posterUrl]);
  const size = measured || known;
  const measure = (width, height) => {
    const next = validSize(width, height);
    if (next) setMeasured((current) => (current?.width === next.width && current?.height === next.height ? current : next));
  };
  return (
    <div className="ad-preview">
      <div className="ad-profile">
        <div className="ad-avatar" aria-hidden="true">{SAMPLE_BUSINESS.initial}</div>
        <div>
          <strong>{SAMPLE_BUSINESS.name}</strong>
          <small>Sponsored · <span aria-hidden="true">◉</span></small>
        </div>
      </div>
      <p className="ad-copy">{primaryText || 'Your ad copy will appear here.'}</p>
      <div className="ad-media" style={size && (videoUrl || posterUrl) ? { aspectRatio: `${size.width} / ${size.height}` } : undefined}>
        {videoUrl
          ? <CatalogVideo src={videoUrl} poster={posterUrl} label={`${mediaLabel} video`} onDimensions={measure} />
          : posterUrl
            ? <img src={posterUrl} alt={`${mediaLabel} poster`} onLoad={(event) => measure(event.currentTarget.naturalWidth, event.currentTarget.naturalHeight)} />
            : <span className="ad-media-empty">Add video or poster</span>}
      </div>
      <div className="ad-caption">
        <div>
          <small>{SAMPLE_BUSINESS.domain}</small>
          <strong>{headline || 'Your headline'}</strong>
        </div>
        <span className="ad-cta">{CTA_LABELS[callToAction] || 'Learn more'}</span>
      </div>
    </div>
  );
}
